import React from "react";
import { hhConfirm } from "./ConfirmDialog.jsx";

/**
 * Floating lock chip shown on Dashboard / Salary / Attendance / KPI tabs.
 * Admin-only. Pulls state from useMonthLock().
 */
export default function LockChip({ monthKey, monthDisplay, locked, tab, onLock, onUnlock }) {
  const visibleTabs = new Set(["salary", "attendance", "dashboard", "kpi"]);
  if (!monthKey || !visibleTabs.has(tab)) return null;

  function handleLock() {
    hhConfirm(
      `Lock ${monthDisplay}? Once locked, attendance, conveyance, and TDS for this month cannot be modified until you unlock it.`,
      () => onLock(monthKey),
      { confirmLabel: "Lock month", title: "Lock payroll month" },
    );
  }

  function handleUnlock() {
    hhConfirm(
      `Unlock ${monthDisplay}? This will allow attendance, KPI, and salary edits for that month again.`,
      () => onUnlock(monthKey),
      { confirmLabel: "Unlock month" },
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 18,
        right: 18,
        zIndex: 90,
        display: "flex",
        gap: 8,
        alignItems: "center",
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 12,
        padding: "8px 12px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
      data-testid="lock-chip"
    >
      {locked ? (
        <>
          <span className="hh-locked-badge">
            <i className="ti ti-lock"></i> {monthDisplay} locked
          </span>
          <button
            className="hh-lock-btn hh-lock-btn-unlock"
            onClick={handleUnlock}
            data-testid="unlock-month-btn"
          >
            <i className="ti ti-lock-open"></i> Unlock
          </button>
        </>
      ) : (
        <>
          <span style={{ fontSize: 11, color: "#666" }}>
            <i className="ti ti-lock-open" style={{ marginRight: 4 }}></i>
            {monthDisplay} open for edits
          </span>
          <button
            className="hh-lock-btn hh-lock-btn-lock"
            onClick={handleLock}
            data-testid="lock-month-btn"
          >
            <i className="ti ti-lock"></i> Lock month
          </button>
        </>
      )}
    </div>
  );
}
